import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// utils
import { darken } from 'polished'

export const Colors = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
`

export const ColorItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
`

export const Swatch = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid ${colors.gray210};
  background: ${({ color }) => color};
  cursor: pointer;
`

// Sits over the swatch's top right corner
export const RemoveButton = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${colors.gray300};
  color: ${colors.white};
  cursor: pointer;

  &:hover {
    background: ${darken(0.1, colors.gray300)};
  }

  svg {
    font-size: 12px;
  }
`

export const ColorCode = styled.div`
  font-size: 10px;
  color: ${colors.gray300};
  text-transform: uppercase;
`

export const AddColor = styled.div`
  display: inline-block;
  margin-top: 8px;
  color: ${colors.blue500};
  cursor: pointer;
  font-weight: 500;
  user-select: none;

  &:hover {
    color: ${darken(0.1, colors.blue500)};
  }
`
